import React, { useContext, useEffect, useState } from 'react';
import UserContext from './index';
import Context from './index';
const UserProvider = (props) => {
    const [userDetails,setUserDetails] = useState({
        id: "",
        roles: null,
        last_login: "",
        is_superuser: false,
        name: "",
        email: "",
        contact: "",
        department: null,
        designation: null,
        signature: null,
        is_staff: false,
        is_active: false,
    })
  return (
    <Context.Provider
      value={{
        ...props,
        userDetails,
        setUserDetails: setUserDetails,
      }}
    >
      {props.children}
    </Context.Provider>
  )
}

export default UserProvider

export function useAPIUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}